import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { GetListOfAssessmentsPerVisit } from "../services/AssessmentsService";
import { PatientVisitSummary } from "../models/PatientVisitSummary";
import { Assessment } from "../models/AssessmentRelated/Assessment";
import {
  currentAssessmentState,
  listOfAssessmentsState,
  networkConnectionStatus,
} from "../data/atoms";
import { VisitTypes } from "../models/Enums";
import "swiper/css";
import "swiper/css/pagination";

interface Props {
  assesements: PatientVisitSummary[];
  patientVisitsCount: any[];
}

const PatientSlider: React.FC<Props> = ({
  assesements,
  patientVisitsCount,
}) => {
  let history = useHistory();

  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [getlistOfAssessmentsState, setlistOfAssessmentsState] = useRecoilState(
    listOfAssessmentsState,
  );
  const [shouldShowNetWorkPopup, setShouldShowNetWorkPopup] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );

  const getVisitTypeName = (id: number) => {
    if (id === VisitTypes.Discharge) {
      return "Discharge";
    } else if (id === VisitTypes.InitialEvaluation) {
      return "Initial Evaluation";
    } else if (id === VisitTypes.Reassessment) {
      return "Reassessment";
    } else if (id === VisitTypes.Screen) {
      return "Screen";
    }
  };

  const getAssessmentNameAndVisitsCount = (
    visitid: number,
    testname: string,
    lookupid: number,
  ) => {
    let assessmentname = "";
    switch (true) {
      case lookupid === 22 && testname === "Gait Test":
      case testname === "3D Kinematic Gait Analysis":
        assessmentname = "Gait Analysis ";
        break;
      case lookupid === 55:
        assessmentname = "Upper Body AROM";
        break;
      case lookupid === 51:
        assessmentname = "Red Light Green Light";
        break;
      case lookupid === 50:
        assessmentname = "Apple Frenzy";
        break;
      case lookupid === 21:
        assessmentname = "Balloon Popper";
        break;
      case lookupid === 41:
        assessmentname = "Veggie Slicer";
        break;
      case lookupid === 31:
        assessmentname = "Time Up and Go";
        break;
      case lookupid === 2:
        assessmentname = "Functional Reach";
        break;
      case lookupid === 1:
        assessmentname = "mCTSIB";
        break;
      default:
        assessmentname = "5X-Sit-To-Stand ";
    }
    if (patientVisitsCount) {
      let totalcount = patientVisitsCount.find((x: any) => {
        if (x.visitId === visitid) {
          return x.count;
        }
      });

      if (totalcount.count > 1) {
        const counttodisplay = totalcount.count - 1;
        return assessmentname + " + " + counttodisplay + " more";
      } else {
        return assessmentname;
      }
    }
  };

  async function getListOfAssessmentAndVisitSummary(
    report: any,
    isViewFullSummary: boolean,
    visitDate: Date,
    visitid: number,
  ) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    let totalvisitscount = patientVisitsCount.find((x: any) => {
      if (x.visitId === visitid) {
        return x.count;
      }
    });
    // when user go to visit summary page, we need to set the current assessment state
    setcurrentAssessmentState((prevState: Assessment) => ({
      ...prevState,
      patientId: report.patientId,
      masterTestId: report.masterTestID,
      masterVisitId: report.masterVisitId,
      assessmentType: report.vbTestLookupId,
      testId: report.vbTestId,
      workstationId: report.workstationId,
      locationId: report.locationId,
      visitId: report.visitId,
      phaseId: 0,
      testJson: "",
      testDateTime: report.testDateTime,
      isViewFullSummary: isViewFullSummary,
    }));
    if (totalvisitscount.count === 1) {
      setTimeout(() => {
        history.push("/patient-assessment-summary", {
          pageHeaderText: "Full Visit Summary",
          isAssessmentCompleted: false,
        });
      }, 200);
    } else {
      await GetListOfAssessmentsPerVisit({
        VisitDate: visitDate,
        patientId: report.patientId,
        specificLocationId: report.locationId,
        VisitId: visitid,
      }).then(async function (response) {
        setlistOfAssessmentsState((prevState: any) => ({
          ...prevState,
          assessments: response?.data.listOfAssessments,
        }));

        history.push("/assessments-list");
      });
    }
  }

  const createDate = (date: any) => {
    let d = new Date(date);
    let dayName = d.toString().split(" ");
    return (
      dayName.slice(0, 2).join(" - ") + " " + dayName.slice(2, 4).join(", ")
    );
  };

  return (
    <Swiper slidesPerView={"auto"} spaceBetween={13}>
      {assesements?.map((report: any) => {
        return (
          <SwiperSlide key={report.visitId}>
            <div className="slide-sec">
              <h2>{report?.visitDate ? createDate(report?.visitDate) : ""}</h2>
              <h3>
                {report?.therapistFirstName !== "" ||
                report?.therapistLastName !== ""
                  ? `${report?.therapistFirstName} ${report?.therapistLastName}`
                  : "N/A"}
              </h3>
              {/* <h4>Visit type:</h4> */}
              {/* <h5>{report ? getVisitTypeName(report.visitTypeId) : "Setting up initial care plan"}</h5> */}
              <h5>
                {getAssessmentNameAndVisitsCount(
                  report?.visitId,
                  report?.testName,
                  report?.vbTestLookupId,
                )}
              </h5>
              <button
                className="visitbtn"
                onClick={() => {
                  getListOfAssessmentAndVisitSummary(
                    report,
                    true,
                    report?.visitDate,
                    report.visitId,
                  );
                }}
              >
                View Visit
              </button>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default PatientSlider;
